// extracted by css-extract-rspack-plugin
export default {"cls1":"AppsMegaMenu-cls1_MKl","cls2":"AppsMegaMenu-cls2_r7- AppsMegaMenu-cls1_MKl"};